const ensureMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) =>
      element.setAttribute(key, value),
    );
    document.head.appendChild(element);
  }
  return element;
};

export const setRouteSeo = ({
  title,
  description,
  canonical,
  robots = "index, follow",
  image = "https://bizsarthi.com/bizsarthi-premium-logo.svg",
}) => {
  const previewHost = /(^|\.)preview\.emergentagent\.com$/i.test(
    window.location.hostname,
  );
  const effectiveRobots = previewHost
    ? "noindex, nofollow, noarchive"
    : robots;
  document.title = title;

  ensureMeta('meta[name="description"]', { name: "description" }).setAttribute(
    "content",
    description,
  );
  ensureMeta('meta[name="robots"]', { name: "robots" }).setAttribute(
    "content",
    effectiveRobots,
  );
  ensureMeta('meta[property="og:title"]', {
    property: "og:title",
  }).setAttribute("content", title);
  ensureMeta('meta[property="og:description"]', {
    property: "og:description",
  }).setAttribute("content", description);
  ensureMeta('meta[property="og:url"]', { property: "og:url" }).setAttribute(
    "content",
    canonical,
  );
  ensureMeta('meta[property="og:image"]', {
    property: "og:image",
  }).setAttribute("content", image);
  ensureMeta('meta[property="og:image:alt"]', {
    property: "og:image:alt",
  }).setAttribute("content", "BizSarthi - The True Sarthi of Your Business");
  ensureMeta('meta[name="twitter:title"]', {
    name: "twitter:title",
  }).setAttribute("content", title);
  ensureMeta('meta[name="twitter:description"]', {
    name: "twitter:description",
  }).setAttribute("content", description);
  ensureMeta('meta[name="twitter:image"]', {
    name: "twitter:image",
  }).setAttribute("content", image);

  let canonicalLink = document.head.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.setAttribute("href", canonical);
};

export const setStructuredData = (id, payload) => {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(payload);
};

export const removeStructuredData = (id) => {
  document.getElementById(id)?.remove();
};
